import { render, staticRenderFns } from "./PinglunDetail.vue?vue&type=template&id=48a4f4c0&scoped=true"
import script from "./PinglunDetail.vue?vue&type=script&lang=js"
export * from "./PinglunDetail.vue?vue&type=script&lang=js"
import style0 from "./PinglunDetail.vue?vue&type=style&index=0&id=48a4f4c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a4f4c0",
  null
  
)

export default component.exports